require("waypoints/lib/noframework.waypoints.js");
import counterUp from "counterup2";
import { siteService } from "../../../services/SiteService";

export default {
    name: "CounterStatistics",

    components: {},

    props: {},

    data: () => {
        return {
            ordersCount: 12000
        };
    },

    created() {
        siteService.getOrdersCount().then(res => {
            this.ordersCount = res.data;
        });
    },

    computed: {},

    mounted() {
        this.checkWaypoint(this);
    },

    methods: {
        countUp: function() {
            // used for counter up effect stats
            const elements = [...document.getElementsByClassName("count")];
            elements.forEach(elem =>
                counterUp(elem, {
                    duration: 3000,
                    delay: 10
                })
            );
        },

        checkWaypoint: function(config) {
            const el = document.querySelector(".TT-counter");
            new Waypoint({
                element: el,
                handler: function() {
                    config.countUp();
                    this.destroy();
                },
                offset: "10%"
            });
        }
    }
};
